import { Theme } from "@mui/material/styles";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";

import { Field } from "../shared/interfaces/Result";

interface Props {
  groupName: any;
  fields?: Field[];
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    listItem: {
      padding: theme.spacing(2),
    },
    checkedIcon: {
      color: theme.palette.success.main,
    },
    answerText: {
      marginLeft: theme.spacing(2),
    },
  }),
);

export function CustomFields(props: Props) {
  const classes = useStyles();

  if (props.fields && props.fields.length > 0)
    return (
      <List key={`list-${props.groupName}`}>
        <ListSubheader key={`listSubheader-${props.groupName}`} disableGutters>
          {props.groupName}
        </ListSubheader>
        {props.fields?.map((questionField: Field) => {
          return (
            <ListItem key={`listItem-${questionField.fieldname}`} dense className={classes.listItem}>
              <ListItemText
                key={`listItemText-${questionField.fieldname}`}
                primary={questionField.fieldname}
                primaryTypographyProps={{ variant: "subtitle2" }}
                secondary={questionField.data}
                secondaryTypographyProps={{
                  variant: "body2",
                  className: classes.answerText,
                }}
              />
            </ListItem>
          );
        })}
      </List>
    );
  else return null;
}
